import { inject, Pipe, PipeTransform } from '@angular/core';
import { InvoicingService } from '../../core/services/invoicing.service';

@Pipe({
  name: 'paymentMethod'
})
export class PaymentMethodPipe implements PipeTransform {

  private invoicingService = inject(InvoicingService);

  transform(value: unknown, isOnlinePayment: boolean): unknown {
    const paymentMethods = this.invoicingService.paymentMethods;
    const chargingMethods = this.invoicingService.chargingMethods;
    const allMethods = [...paymentMethods, ...chargingMethods];
    const method = allMethods.find(m => m.value === value && m.isOnlinePayment === isOnlinePayment);
    return method ? method.label : null;
  }
}
